import React from 'react';
import { Table } from 'react-bootstrap';
import DeviceRow from 'containers/Devices/DeviceRow';

const DeviceTable = ({ list, hideVendors }) => {
  return (
    <Table striped condensed hover>
      <thead>
        <tr>
          {hideVendors ? null : <th>Manufacturer</th>}
          <th>Model Name / Number</th>
          <th>Device Type</th>
          <th>Certification Date</th>
        </tr>
      </thead>
      <tbody>
        <DeviceRow tableData={list} hideVendors={hideVendors} />
      </tbody>
    </Table>
  );
};

export default DeviceTable;



// WEBPACK FOOTER //
// ./src/containers/Devices/DeviceTable.js